import { render, staticRenderFns } from "./InventoryAvailabilityView.vue?vue&type=template&id=50b38f0d&scoped=true"
import script from "./InventoryAvailabilityView.vue?vue&type=script&lang=js"
export * from "./InventoryAvailabilityView.vue?vue&type=script&lang=js"
import style0 from "./InventoryAvailabilityView.vue?vue&type=style&index=0&id=50b38f0d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b38f0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b38f0d')) {
      api.createRecord('50b38f0d', component.options)
    } else {
      api.reload('50b38f0d', component.options)
    }
    module.hot.accept("./InventoryAvailabilityView.vue?vue&type=template&id=50b38f0d&scoped=true", function () {
      api.rerender('50b38f0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryReservation/InventoryAvailabilityView.vue"
export default component.exports